module.exports = __webpack_public_path__ + "static/media/innanverdlaeri_small.b933aec0.png";